// The assistant on every page: a button that opens a drawer with the chat, carrying the current record as context.
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { pageContext, useAssistantEnabled } from '@/lib/assistant';
import { AssistantPanel } from '@/pages/assistant/AssistantPanel';

export function AssistantDrawer() {
  const enabled = useAssistantEnabled();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  // the panel is rebuilt only by "New"; its own first message fills in the conversation id without rebuilding it
  const [panel, setPanel] = useState<{ key: number; conv: string | null }>({ key: 0, conv: null });
  const conversationId = panel.conv;
  if (!enabled || loc.pathname.startsWith('/assistant')) return null;
  const context = pageContext(loc.pathname);
  return (
    <>
      <button type="button" className="ai-fab" onClick={() => setOpen((x) => !x)} aria-expanded={open} title="Assistant">✦ Assistant</button>
      {open && (
        <aside className="ai-drawer" aria-label="Assistant">
          <div className="ai-drawer-head">
            <b>Assistant</b>{context && <small className="muted"> · about this {String(context.entity).replace('_', ' ')}</small>}
            <span style={{ marginLeft: 'auto' }} className="row">
              <button type="button" className="btn btn-ghost btn-sm" onClick={() => setPanel((x) => ({ key: x.key + 1, conv: null }))}>New</button>
              <Link className="btn btn-ghost btn-sm" to={conversationId ? `/assistant/c/${conversationId}` : '/assistant'} state={{ context }}>Full page</Link>
              <button type="button" className="toast-x" aria-label="Close" onClick={() => setOpen(false)}>×</button>
            </span>
          </div>
          <AssistantPanel key={panel.key} compact conversationId={conversationId} context={context} onConversation={(cid) => setPanel((x) => ({ ...x, conv: cid }))} />
        </aside>
      )}
    </>
  );
}
